/*
 ** TailwindCSS Configuration File
 **
 ** Docs: https://tailwindcss.com/docs/configuration
 ** Default: https://github.com/tailwindcss/tailwindcss/blob/master/stubs/defaultConfig.stub.js
 */
module.exports = {
	purge: {
		content: [
			'./components/**/*.{js,vue,ts}',
			'./layouts/**/*.vue',
			'./pages/**/*.vue',
			'./plugins/**/*.{js,ts}',
			'./nuxt.config.{js,ts}',
			'./app.vue',
		],
		options: {
			safelist: [
				// ActionsGroup component
				/^actions-group__/,
				// CalendarDay component
				/^day--/,
				// Widget components
				/^widget-item--/,
				/^widget-badge--/,
				// Hours exceeding classes
				/^hours-exceeding--/,
				// Timecard components
				/^timecard-day__/,
				/^timecard-summary--/,
				/^timecard-item--/,
				/^timecard-list-item/,
				/^timecard-week-/,
				// Holiday components
				/^holidays-summary--/,
				/^holiday-progress__/,
				// Row actions
				/^row-action--/,
				// State classes
				'is-today',
				'is-selected',
				// Element UI
				/^el-/,
				// Flag icons
				/^flag-/,
			],
		},
	},
	theme: {},
	variants: {},
	plugins: [],
};
